import { projects } from '__mocks__/projects';
import { ProjectsTable } from './ProjectsTable';

export const AssociatedProjects = () => {
  return <ProjectsTable projects={projects} />;
};
